import { render, staticRenderFns } from "./vip-level-icon.vue?vue&type=template&id=9c7a5f24&scoped=true"
import script from "./vip-level-icon.vue?vue&type=script&lang=js"
export * from "./vip-level-icon.vue?vue&type=script&lang=js"
import style0 from "./vip-level-icon.vue?vue&type=style&index=0&id=9c7a5f24&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c7a5f24",
  null
  
)

export default component.exports